import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import { Form, Modal } from "@components";
import React, { useCallback, useContext } from "react";
import { useHistory } from "react-router";
import { UPDATE_FILTERS_DATA } from "../state";
import { TableContext } from "../table";
import { Search } from "./search-filters";
import { Actions } from "../../../screens/request/components/actions";
import CloseIcon from "@material-ui/icons/Close";
import { Api } from "@api";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { sub } from "date-fns";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { PanoramaFishEyeRounded } from "@material-ui/icons";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  onSearchDate: (name: string, value: MaterialUiPickersDate) => void;
}

type FormValues = {
  name: string;
  isActive: boolean;
};

type Key = keyof FormValues;

export const FeedbackToolbar: React.FC<Props> = ({ onSearchDate }) => {
  const history = useHistory();
  const { dispatch } = useContext(TableContext);
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = React.useState<
    boolean
  >(false);
  const [pending, setPending] = React.useState(false);

  const form = Form.useManager<FormValues>({
    name: "",
    isActive: false,
  });

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    form.reset();
    setOpen(false);
  };
  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const [startDate, setStartDate] = React.useState<MaterialUiPickersDate>(
    sub(new Date(), { days: 30 })
  );

  const [endDate, setEndDate] = React.useState<MaterialUiPickersDate>(
    new Date()
  );

  const updateDate = ( name: string, value: MaterialUiPickersDate ) => {
    
    if (name === "startDate") {
      setStartDate(value);
    }

    if (name === "endDate") {
      setEndDate(value);
    }

    onSearchDate(name, value);
  };


  return (
    <Box mt={2} mb={2}>
      <Grid item xs={12}>
        <Form>
          <Form.Group label="Filter by Date">
            <Form.Datebox
              label={"Start Date"}
              name="startDate"
              onChange={updateDate}
              size={12}
              value={startDate}
            />
            <Form.Datebox
              label={"End Date"}
              name="endDate"
              onChange={updateDate}
              size={12}
              value={endDate}
            />
          </Form.Group>
        </Form>
      </Grid>
    </Box>
  );
};
